import bevImg from '../assets/images/Pet-beverage-filling-line.png';
import packagingImg from '../assets/images/Packaging&Systems.jpg';
import plasticsImg from '../assets/images/integratedplastic.jpg';
import healthcareImg from '../assets/images/Medical-pharma-paxkaging-mold.jpg';

const industriesData = [
  {
    id: 1,
    name: "Beverage",
    slug: "beverage",
    description: "Solutions for bottling, filling, and packaging in the beverage industry.",
    image: bevImg
  },
  {
    id: 2,
    name: "Packaging",
    slug: "packaging",
    description: "Equipment and systems for various packaging applications.",
    image: packagingImg
  },
  {
    id: 3,
    name: "Plastics",
    slug: "plastics",
    description: "Specialized technology for plastic manufacturing and processing.",
    image: plasticsImg
  },
  {
    id: 4,
    name: "Healthcare",
    slug: "healthcare",
    description: "Precision equipment for medical device manufacturing and healthcare applications.",
    image: healthcareImg
  }
];

export default industriesData;